<template>
    <div class="titulo">
        <div class="margem container">
            <div class="m-icone esquerda"><a @click="this.$router.back();" style="cursor: pointer;"
                    class="icone-voltar m-d"></a></div>
            <div class="m-icone direita">
                <div class="pesquisa">
                    <input type="text" placeholder="Pesquisar" />
                    <a disabled class="icone-pesquisa"></a>
                </div>
            </div>
            <h2>Reuniões</h2>
        </div>
    </div>
    <div class="margem container">
        <div class="bloco margem">
            <template v-if="!loading">
                <div class="submit direita">
                    <v-btn icon="mdi-file-download-outline" class="acao-secundaria" title="Baixar Relatório"
                        @click="baixarRelatorio()" v-if="funcionalidades.includes(123)"></v-btn>
                    <v-btn icon="mdi-plus" class="acao-secundaria" @click="abrirReunião('criar')"></v-btn>
                </div>
                <table class="tabela">
                    <tbody>
                        <tr>
                            <th v-for="l, index in labels" :key="index">{{ l.label }}</th>
                            <th>Excluir</th>
                        </tr>
                        <tr v-for="reuniao, index in reuniões" :key="index" @click="abrirReunião(reuniao.id)">
                            <template v-for="l, index in labels" :key="index">
                                <td v-if="l.type == 'dataHora'">{{ `${formatarData(reuniao.data)}
                                    ${reuniao.hora?.slice(0,
                                    5)}` }}</td>
                                <td v-else-if="l.chave == 'tipo' || l.chave == 'status'">{{ reuniao[l.chave].descricao
                                    }}
                                </td>
                                <td v-else-if="l.chave == 'setor'">{{ formatarNome(reuniao[l.chave].nome) }}
                                </td>
                                <td v-else-if="l.chave == 'responsavel'">{{ reuniao[l.chave].nome }}
                                </td>
                                <td v-else>{{ reuniao[l.chave] }}</td>
                            </template>
                            <td @click.stop><i @click="excluirReunião(reuniao.id)" class="bi-trash"></i></td>
                        </tr>
                    </tbody>
                </table>
                <div class="paginacao-container">
                    <div class="paginacao">
                        <template v-for="l in dadosPaginacao.links" :key="l">
                            <a v-if="l.label != 'pagination.previous' && l.label != 'pagination.next'"
                                :class="{ 'ativo': l.active }" @click="paginaAtual = l.label; getReuniões()">
                                {{ l.label }}
                            </a>
                            <span v-else-if="l.label == 'pagination.previous'"
                                @click="l.url ? (paginaAtual = l.url.split('?')[1].split('=')[1], getReuniões()) : null">
                                <i class="icon bi-caret-left-fill"></i>
                            </span>
                            <span v-else-if="l.label == 'pagination.next'"
                                @click="l.url ? (paginaAtual = l.url.split('?')[1].split('=')[1], getReuniões()) : null">
                                <i class="icon bi-caret-right-fill"></i>
                            </span>
                        </template>
                    </div>

                    <div class="paginacao-select">
                        <label>Qtd p/ página</label>
                        <select v-model="qtPorPagina" @change="getReuniões()">
                            <option>10</option>
                            <option>20</option>
                            <option>50</option>
                            <option>100</option>
                        </select>
                    </div>
                </div>
            </template>
            <div v-else class="loading">
                <div></div>
            </div>
        </div>
    </div>
</template>

<script>
import service from '@/services/serviceReuniões';
import { getPermissao } from '@/services/permissao-service'
export default {
    data() {
        return {
            labels: [],
            reuniões: [],
            funcionalidades: [],
            paginaAtual: '1',
            qtPorPagina: 20,
            dadosPaginacao: null,
            loading: true
        }
    },
    async mounted() {
        this.getReuniões();
        this.funcionalidades = await getPermissao()
    },
    methods: {
        baixarRelatorio() {
            service.baixarRelatorio()
        },
        formatarNome(nome) {
            return nome.replace(/^(\d+\.*\s*)+/, '')
        },
        async excluirReunião(id) {
            const confirmacao = confirm('Deseja realmente excluir a reunião?')
            if (confirmacao) {
                await service.excluirReunião(id)
                this.getReuniões()
            }
        },
        async getReuniões() {
            const response = await service.getReuniões(this.qtPorPagina, this.paginaAtual)
            this.reuniões = response.data;
            this.labels = response.labels;
            this.dadosPaginacao = response.paginacao
            this.loading = false
        },
        abrirReunião(id) {
            this.$router.push({ name: 'reuniaoView', params: { id: id } })
        },
        formatarData(data) {
            const partes = data.split('-')
            return `${partes[2]}/${partes[1]}/${partes[0]}`
        },
    },
}
</script>

<style scoped>
.icon {
    color: var(--cor-fonte-fraca);
}

.mdi-plus {
    background-color: var(--cor-bg) !important;
}

i {
    color: var(--cor-erro);
    font-size: 16px;
    transition: all 200ms ease-in;
}

i:hover {
    cursor: pointer;
    transform: scale(1.1);
}
</style>